import { red } from '@material-ui/core/colors';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
// import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

// const breakpoints = createBreakpoints({});
// A custom theme for this app

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#191838',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#eaeaf0',
    },
  },
  typography: {
    fontFamily: 'Lato, sans-serif !important',
  },
  overrides: {
    MuiAppBar: {
      positionRelative: {
        paddingRight: '0px',
        paddingLeft: '0px',
      },
    },
    MuiContainer: {
      root: {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
        maxWidth: '100% !important',
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: '#eaeaf0',
      },
    },
    MuiDrawer: {
      paper: {
        // top: "0px",
      },
    },
    MuiAccordion: {
      root: {
        // color:'blue',
        '&$expanded': {
          // color:'yellow',
          marginBottom: 0,
          backgroundColor: '#564e43',
        },
      },
    },
    MuiAccordionSummary: {
      root: {
        minHeight: '40px',
        height: '40px',
        '&$expanded': {
          minHeight: '40px',
          height: '40px',
          backgroundColor: '#564e43',
        },
      },
    },
  },
  zIndex: {
    appBar: 1301,
    drawer: 1299,
    modal: 1300,
  },
});

export default responsiveFontSizes(theme);
